interface YearData {
  year: number | string;
  share_percentage: string;
  enabled: boolean;
}

export interface InitialValuesYears {
  years: YearData[];
}
export interface Location {
  name: string;
  category?: string | number;
  city: string;
  street: string;
  country: string;
  province: string;
  provinceCode: string;
  postalCode: string | null;
  latitude: string;
  longitude: string;
  belongs?: string | number;
  countryCode: string;
  years: YearData[];
}

export interface InitialValuesProp {
  locations: Location[];
}
export const initialValues: InitialValuesProp = {
  locations: [
    {
      name: '',
      category: undefined,
      city: '',
      street: '',
      country: '',
      province: '',
      provinceCode: '',
      postalCode: null,
      latitude: '',
      longitude: '',
      belongs: undefined,
      countryCode: '',
      years: [],
    },
  ],
};
export const ALPHANUMERIC_REGEX = /^[a-zA-Z0-9 ]*$/;

export const ALPHANUMERIC_WITH_SPECIAL_REGEX = /^[a-zA-Z0-9@&*,.":; ]*$/;

export const LocationFieldNames = {
  CATEGORY: 'category',
};
